module.exports = __webpack_public_path__ + "img/part-banner.401677ae.jpg";